import { httpService as a } from "@waitroom/http-client";
import { buildApiParamsWithAuth as e } from "../helpers.es.js";
const o = {
  // Used to let a user connect their google calendar to recall
  getGoogleAuthURL: async () => {
    var r;
    return ((r = (await a.get(
      await e("/transcriptions/bot/google-auth")
    )).data) == null ? void 0 : r.authURL) ?? "";
  },
  // ATTN: Only google is supported for now:
  disconnectCalendar: async (t) => {
    await a.post(
      await e("/transcriptions/bot/disconnect", {
        data: {
          platform: t
        }
      })
    );
  },
  getCalendarUser: async () => (await a.get(
    await e("/transcriptions/bot/calendar-user")
  )).data ?? null
};
export {
  o as recallCalendarService
};
